import { apiGet, apiPatch, apiPost, apiPut } from "./client";

export type BranchRow = {
  id: string;
  slug: string;
  name: string;
};

export type BranchAccessMember = {
  userId: string;
  email: string | null;
  displayName: string | null;
  userCode: string | null;
  branchIds: string[];
  unrestricted: boolean;
};

export function listBranches(companyRef: string) {
  return apiGet<{
    branches: BranchRow[];
    allowedBranchIds: string[];
    showPicker: boolean;
  }>(`/c/${companyRef}/branches`);
}

export function createBranch(
  companyRef: string,
  body: { name: string; slug?: string },
) {
  return apiPost<{
    branch: BranchRow;
    warehouse: { id: string; code: string; name: string };
  }>(`/c/${companyRef}/branches`, body);
}

export function updateBranch(
  companyRef: string,
  branchId: string,
  body: { name: string },
) {
  return apiPatch<{ branch: BranchRow }>(
    `/c/${companyRef}/branches/${branchId}`,
    body,
  );
}

export function getBranchAccess(companyRef: string) {
  return apiGet<{
    branches: BranchRow[];
    showPicker: boolean;
    members: BranchAccessMember[];
  }>(`/c/${companyRef}/settings/branch-access`);
}

export function setMemberBranches(
  companyRef: string,
  userId: string,
  body: { branchIds: string[]; unrestricted?: boolean },
) {
  return apiPut<{
    userId: string;
    branchIds: string[];
    unrestricted: boolean;
  }>(`/c/${companyRef}/settings/branch-access/${userId}`, body);
}
